/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const deleteMonitoringIntegrationBodyExpectedVersionExclusiveMin = 0;
export const deleteMonitoringIntegrationBodyExpectedVersionMax = 9007199254740991;

export const DeleteMonitoringIntegrationBody = zod.object({
  expectedVersion: zod
    .int()
    .gt(deleteMonitoringIntegrationBodyExpectedVersionExclusiveMin)
    .max(deleteMonitoringIntegrationBodyExpectedVersionMax),
});

export type DeleteMonitoringIntegrationBody = zod.input<typeof DeleteMonitoringIntegrationBody>;
export type DeleteMonitoringIntegrationBodyOutput = zod.output<
  typeof DeleteMonitoringIntegrationBody
>;
